import { useHasRole } from '../auth/useRoles'
import { CompaniesPage } from './CompaniesPage'
import { DashboardPage } from './DashboardPage'

export function RoleBasedHome() {
  const isAdmin = useHasRole('admin')

  if (isAdmin) {
    return <CompaniesPage />
  }

  return <DashboardPage />
}
